function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Drawer, message, Tree } from 'antd';
import { NodePlusFill, XSquareFill } from 'react-bootstrap-icons';
import NewDepartment from "../components/forms/NewDepartment";
import NewService from "../components/forms/NewService";
import NewExam from "../components/forms/NewExam";
import Common from "../components/includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Departments = function Departments() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewDeptFormVisible = _useState2[0],
    setIsNewDeptFormVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNewServiceFormVisible = _useState4[0],
    setIsNewServiceFormVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewItemFormVisible = _useState6[0],
    setIsNewItemFormVisible = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    serviceTree = _useState8[0],
    setServiceTree = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    dataChanged = _useState0[0],
    setDataChanged = _useState0[1];
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getservicetree').then(function (response) {
      if (response.data.status == 200) {
        response.data.services.forEach(function (d) {
          setServiceTree(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              title: d.label,
              key: 'd' + d.id.toString(),
              children: d.services.map(function (s) {
                return {
                  title: s.label,
                  key: "s" + s.id.toString(),
                  children: s.medical_items.map(function (m) {
                    return {
                      title: m.label,
                      key: "m" + m.id.toString()
                    };
                  })
                };
              })
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 9,
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "vertical",
            children: [/*#__PURE__*/_jsx(Button, {
              size: "large",
              type: "primary",
              style: {
                width: '98%'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewDeptFormVisible(true);
              },
              children: "Ajouter Deptm"
            }), /*#__PURE__*/_jsx(Button, {
              size: "large",
              type: "primary",
              style: {
                width: '98%'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewServiceFormVisible(true);
              },
              children: "Ajouter Service"
            }), /*#__PURE__*/_jsx(Button, {
              size: "large",
              type: "primary",
              style: {
                width: '98%'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewItemFormVisible(true);
              },
              children: "Ajouter un examen"
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          sm: 9,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsx(Tree, {
              showLine: true,
              showIcon: true,
              defaultExpandAll: true,
              autoExpandParent: true,
              defaultExpandParent: true,
              treeData: serviceTree
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewDeptFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un d\xE9partement",
      onClose: function onClose() {
        setIsNewDeptFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewDepartment, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewServiceFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un service",
      onClose: function onClose() {
        setIsNewServiceFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewService, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewItemFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un examen",
      onClose: function onClose() {
        setIsNewItemFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewExam, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    })]
  });
};
export default Departments;